/* Parametres de pre-remplissage venus du site SEO (front-next).

   Ils arrivent desormais dans le FRAGMENT (#service=whatsapp&country=usa) et non
   plus dans la query string. Google ignore le fragment : ces liens ne creent plus
   une URL a crawler par combo. Constate le 08/10/2026 : 34 % du crawl de Googlebot
   partait sur /app/<langue>?service=...&country=... (5 997 URLs, toutes en
   noindex), au detriment des pages SEO en attente d'indexation.

   La query string reste lue en premier : les anciens liens (deja connus de Google,
   envoyes par email, en favoris) continuent de fonctionner. */
export function deepParam(searchParams, name) {
  const viaQuery = searchParams && searchParams.get(name);
  if (viaQuery) return viaQuery;
  const fragment = (window.location.hash || "").replace(/^#/, "");
  return new URLSearchParams(fragment).get(name) || "";
}
